import { render, staticRenderFns } from "./logoutBtn.vue?vue&type=template&id=fe84e5ea&scoped=true&lang=pug&"
import script from "./logoutBtn.vue?vue&type=script&lang=js&"
export * from "./logoutBtn.vue?vue&type=script&lang=js&"
import style0 from "./logoutBtn.vue?vue&type=style&index=0&id=fe84e5ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe84e5ea",
  null
  
)

export default component.exports